export enum TemperatureUnits {
  Celsius,
  Kelvin,
  Fahrenheit,
}
